import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetOneTicketLogs(club, id) {
  var url = "/reservation/get_ticket_logs/" + club + "/" + id + "/0";

  return FetchGetDataWithAuthNEW(url);
}
